export const noIdPath = [
  'home',
  'payList',
  'humanList',
  'humanYsList',
  'projectpayList',
  'ruzhu',
  'e-contractList',
  'pCenter',
  'account',
  'person',
  'order',
  'bill'
];
export const needIdPath = [
  //需要重新赋值的路径
  'edit',
  'edit-next',
  'assign',
  'record',
  'human',
  'settle',
  'riskCtrl',
  'signInfo',
  // 'bi',
  'sceneEdit',
  'personnelIndex',
  'personnelList',
  'questionEdit'
];
export const openTypeList = [
  {
    label: '会务服务',
    value: 1
  },
  {
    label: '咨询服务',
    value: 2
  },
  {
    label: '推广服务',
    value: 3
  }
];
export const taxList = [
  {
    label: '增值税普通发票',
    value: 1
  },
  {
    label: '增值税专用发票',
    value: 2
  }
];
export const orderTypeList = [
  {
    value: 1,
    label: '支付订单'
  },
  {
    value: 2,
    label: '综合服务费'
  }
];
export const mallGoodGroup = [
  {
    label: '等级权限',
    value: 1
  },
  {
    label: '限量闪兑',
    value: 2
  },
  {
    label: '积分豪兑',
    value: 3
  }
];
// 题库中 废弃 耻辱
export const courseType = [
  {
    label: '直播',
    value: 1
  },
  {
    label: '录播',
    value: 2
  }
];
// 课程中
export const courseType2 = [
  {
    label: '直播',
    value: 1
  },
  {
    label: '录播',
    value: 0
  }
];
// 是否
export const whetherOrNot = [
  {
    label: '是',
    value: 1
  },
  {
    label: '否',
    value: 0
  }
];
export const payStatus = [
  {
    label: '未支付',
    value: 0
  },
  {
    label: '已支付',
    value: 1
  }
];
export const businessCommentReviewed = [
  {
    label: '未通过',
    value: 0
  },
  {
    label: '已通过',
    value: 1
  }
];
export const projectOrderPayStatus = [
  {
    label: '待支付',
    value: 1
  },
  {
    label: '支付中',
    value: 2
  },
  {
    label: '支付失败',
    value: 3
  },
  {
    label: '部分支付成功',
    value: 4
  }
];
export const projectOrderPayStatus2 = [
  {
    label: '待支付',
    value: 0
  },
  {
    label: '支付中',
    value: 1
  },
  {
    label: '支付成功',
    value: 2
  },
  {
    label: '支付失败',
    value: 3
  }
];
export const onlinePromotionContentType = [
  {
    label: '课程',
    value: 1
  },
  {
    label: '资讯',
    value: 2
  },
  {
    label: '病例',
    value: 3
  }
];
// 任务记录中状态与全局filter
export const recordStatus = [
  {
    label: '审核中',
    value: 1
  },
  {
    label: '审核通过',
    value: 2
  },
  {
    label: '审核未通过',
    value: 3
  }
];

// 结算管理
export const payFinishList = [
  {
    label: '未付钱',
    value: 0
  },
  {
    label: '付款中',
    value: 1
  },
  {
    label: '已付款',
    value: 2
  },
  {
    label: '付款失败',
    value: 3
  }
];
export const linkStatus3 = [
  {
    value: 0,
    label: '未签约'
  },
  {
    value: 1,
    label: '签约中'
  },
  {
    value: 2,
    label: '签约成功'
  },
  {
    value: 3,
    label: '签约失败'
  },
  {
    value: 4,
    label: '已补录'
  }
];
export const linkStatus4 = [
  {
    value: 0,
    label: '未签约'
  },
  {
    value: 1,
    label: '签约中'
  },
  {
    value: 2,
    label: '签约成功'
  },
  {
    value: 3,
    label: '签约失败'
  }
];
// filePath不可以修改
export const projectAllList = [
  //所有项目类型及路径由此维护
  {
    //1 有详情
    filePath: 'academy',
    name: '学术拜访',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/xueshuhuodong.png',
    projectType: 1
  },
  {
    //2 有详情
    filePath: 'otc',
    name: 'OTC拜访',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/otcbaifang.png',
    projectType: 2
  },
  {
    //3 有详情
    filePath: 'ksh',
    name: '科室会',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/keshihui.png',
    projectType: 3
  },
  {
    //4 有详情
    filePath: 'hjh',
    name: '患教会',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/keshihui.png',
    projectType: 4
  },
  {
    //5 有详情
    filePath: 'survey',
    name: '医学助手项目调研',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/huanzhediaoyan.png',
    projectType: 5
  },
  {
    //6 有详情
    filePath: 'channel',
    name: '线上推广',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/xianshangtuiguang.png',
    projectType: 6
  },
  {
    // 7 有详情
    filePath: 'survey',
    name: '医生调查问卷',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/yixuediaoyan.png',
    projectType: 7
  },
  {
    // 8 有详情
    filePath: 'case',
    name: '病例收集',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/binglishouji.png',
    projectType: 8
  },
  {
    // 9 有详情
    filePath: 'lvlHospital',
    name: '等级医院拜访',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/dengjiyiyuanbaifang.png',
    projectType: 9
  },
  {
    // 10 有详情
    filePath: 'baseHospital',
    name: '基层医疗机构拜访',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/jicengyiliaojigoubaifang.png',
    projectType: 10
  },
  {
    // 11 无详情
    filePath: 'accessSuper',
    name: '特级三甲医院市场准入',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/tejisanjiayiyuanshichangzhunru.png',
    projectType: 11
  },
  {
    // 12 无详情
    filePath: 'accessSuper',
    name: '三级医院市场准入',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/sanjiyiyuanshichangzhunru.png',
    projectType: 12
  },
  {
    //13 无详情
    filePath: 'accessSuper',
    name: '二级医院市场准入',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/erjiyiyuanshichangzhunru.png',
    projectType: 13
  },
  {
    //14 无详情
    filePath: 'accessSuper',
    name: '基层医疗机构市场准入',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/jicengyiliaojigoushichangzhunru.png',
    projectType: 14
  },
  {
    //15 无详情
    filePath: 'accessSuper',
    name: '零售药店市场准入',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/lingshouyaodianshichangzhunru.png',
    projectType: 15
  },
  // {
  //   // 16
  //   filePath: 'digital',
  //   name: '健康',
  //   projectDefaultBg:
  //     'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/shuzibaifang.png',
  //   projectType: 16
  // },
  {
    // 17 有详情
    filePath: 'digital',
    name: '数字拜访',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/shuzibaifang.png',
    projectType: 17
  },
  {
    // 18 有详情
    filePath: 'zsCase',
    name: '助手病例',
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/binglishouji.png',
    projectType: 18
  },
  {
    // 19 无详情
    filePath: 'protocolService',
    name: '协定服务',
    projectType: 19
  },
  {
    // 20 有详情
    filePath: 'editScene',
    name: '可配置场景',
    projectType: 20
  },
  {
    //21 有详情
    filePath: 'digitalSurvey',
    name: '数字问卷',
    //TODO 待修改
    projectDefaultBg:
      'https://cdn.yxvzb.com/WEB/SaaS/images/projectBanner/yixuediaoyan.png',
    projectType: 21
  }
];
export const checkTax = (rule, value, callback) => {
  const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/;
  if (!reg.test(value)) {
    callback(new Error('格式不正确'));
  } else if (value > 100 || value < 0) {
    callback(new Error('数值不正确'));
  } else {
    callback();
  }
};
// 项目类型 1学术拜访  2 OTC巡访  3 科室会  4 患教会 5 助手调查问卷  6 专区  7医生调查问卷  8病例 9 等级医院拜访 10 基层医疗机构拜访
export const backgroundList = [
  { label: '医生', id: 1 },
  { label: '护士', id: 2 },
  { label: '健康管理师', id: 3 },
  { label: '市场人员', id: 4 },
  { label: '临床协调员', id: 5 },
  { label: '临床监察员', id: 6 },
  { label: '药店店员', id: 7 },
  { label: '药师', id: 8 },
  { label: '其他', id: 10 }
];
// 问卷类型  类型 1 单选 2 多选 3 单项投票 4 单项填空 5 多项填空 6 打分题 7 地址
export const questionType = {
  '-3': {
    label: '定位题',
    value: -3
  },
  '-2': {
    label: '时间题',
    value: -2,
    children: {
      1: {
        label: '时间段题',
        value: -2,
        secondType: 1
      },
      2: {
        label: '时刻题',
        value: -2,
        secondType: 2
      }
    }
  },
  '-1': {
    label: '目标题',
    value: -1
  },
  1: {
    label: '单选题',
    value: 1
  },
  2: {
    label: '多选题',
    value: 2
  },
  3: {
    label: '单选投票题',
    value: 3
  },
  4: {
    label: '单项填空题',
    value: 4
  },
  5: {
    label: '多项填空题',
    value: 5
  },
  6: {
    label: '打分题',
    value: 6
  },
  7: {
    label: '地址',
    value: 7
  },
  8: {
    label: '上传附件',
    value: 8
  },
  9: {
    label: '上传pdf',
    value: 9
  },
  10: {
    label: '上传word',
    value: 10
  },
  11: {
    label: '上传excel',
    value: 11
  },
  12: {
    label: '上传ppt',
    value: 12
  },
  13: {
    label: '上传图片',
    value: 13
  },
  14: {
    label: '时间题',
    value: 14
  },
  15: {
    label: '月度题',
    value: 15
  },
  16: {
    label: '定位题',
    value: 16
  },
  17: {
    label: '描述题',
    value: 17
  },
  18: {
    label: '描述题',
    value: 18
  },
  19: {
    label: '数字填空题',
    value: 19
  },
  20: {
    label: '签名题',
    value: 20
  },
  21: {
    label: '签到题', // 未使用
    value: 21
  },
  22: {
    label: '姓名填空题',
    value: 22
  },
  29: {
    label: '时刻题',
    value: 29
  },
  30: {
    label: '受访者来源',
    value: 30
  }
};

// 业务结构
export const bType = [
  {
    key: 1,
    aId: 1,
    name: '四级汇总',
    orderPath: '/dingdan/four',
    cArr: [
      {
        key: 1,
        aId: 1,
        showTotalMoney: true, // 分配任务列表 显示项目结算金额（含税）字段
        name: '工业-ASP-P-C'
      }
    ]
  },
  {
    key: 2,
    aId: 2,
    name: '三级汇总',
    orderPath: '/dingdan/threeTotal',
    cArr: [
      {
        key: 1,
        aId: 2,
        name: '工业-P-C'
      },
      {
        key: 2,
        aId: 3,
        name: 'ASP-P-C'
      }
    ]
  },
  {
    key: 3,
    aId: 3,
    name: '三级代开',
    orderPath: '/dingdan/threeEntrusted',
    cArr: [
      {
        key: 1,
        aId: 4,
        showTotalMoney: true, // 分配任务列表 显示项目结算金额（含税）字段
        name: '工业-ASP-C'
      }
    ]
  },
  {
    key: 4,
    aId: 4,
    name: '二级代开',
    orderPath: '/dingdan/twoEntrusted',
    cArr: [
      {
        key: 1,
        aId: 5,
        name: '工业-C'
      },
      {
        key: 2,
        aId: 6,
        name: 'ASP-C'
      }
    ]
  },
  {
    key: 5,
    aId: 5,
    name: '三级灵工服务',
    orderPath: '/dingdan/threeFlex',
    cArr: [
      {
        key: 1,
        aId: 7,
        showTotalMoney: true, // 分配任务列表 显示项目结算金额（含税）字段
        name: '工业-薪未来-C'
      },
      {
        key: 2,
        aId: 8,
        name: 'ASP-薪未来-C'
      }
    ]
  },
  {
    key: 6,
    aId: 6,
    name: '二级灵工服务',
    orderPath: '/dingdan/twoFlex',
    cArr: [
      {
        key: 1,
        aId: 9,
        name: '薪未来-C'
      }
    ]
  },
  {
    key: 7,
    aId: 7,
    name: '三级个体',
    orderPath: '/dingdan/threeCompany',
    cArr: [
      {
        key: 1,
        aId: 10,
        showTotalMoney: true, // 分配任务列表 显示项目结算金额（含税）字段
        name: '工业-ASP-个体'
      }
    ]
  },
  {
    key: 8,
    aId: 8,
    name: '二级个体',
    orderPath: '/dingdan/twoCompany',
    cArr: [
      {
        key: 1,
        aId: 11,
        name: '工业-个体'
      },
      {
        key: 2,
        aId: 12,
        name: 'ASP-个体'
      }
    ]
  },
  {
    key: 9,
    aId: 9,
    name: '工具',
    cArr: [
      {
        key: 1,
        aId: 4,
        name: '工业-ASP-C（不支付）'
      },
      {
        key: 2,
        aId: 5,
        name: '工业-C（不支付）'
      },
      {
        key: 3,
        aId: 6,
        name: 'ASP-C（不支付）'
      },
      {
        key: 4,
        aId: 10,
        name: '工业-ASP-个体（不支付）'
      },
      {
        key: 5,
        aId: 11,
        name: '工业-个体（不支付）'
      },
      {
        key: 6,
        aId: 12,
        name: 'ASP-个体（不支付）'
      }
    ]
  }
  // {
  //   key: 10,
  //   aId: 10,
  //   name: '三级代开(云代开)',
  //   orderPath: '/dingdan/twoCompany',
  //   cArr: [
  //   ]
  // },
  // {
  //   key: 11,
  //   aId: 11,
  //   name: '二级代开(云代开)',
  //   orderPath: '/dingdan/twoCompany',
  //   cArr: [
  //   ]
  // },
];

// 获取业务结构
export const getBtypeObj = businessType => {
  if (!businessType) {
    return {
      name: '未设置',
      cArr: []
    };
  }
  return (
    bType.find(i => i.aId == businessType) || {
      name: '未设置',
      cArr: []
    }
  );
};

// 获取具体模式
export const getModeObj = (businessType, patternType) => {
  return (
    getBtypeObj(businessType).cArr.find(i => i.aId == patternType) || {
      name: '未设置'
    }
  );
};

// 项目类型对应项目名称
// key为项目类型
// assistantName为数分析中content-name，在数据分析中会用该字段匹配对应tab下标
export const projectTypeMap = {
  1: { name: '学术拜访', value: 1, assistantName: '学术拜访' },
  2: { name: 'OTC拜访', value: 2, assistantName: 'OTC拜访' },
  3: { name: '科室会', value: 3, assistantName: '科室会' },
  4: { name: '患教会', value: 4, assistantName: '患教会' },
  5: { name: '患者调研', value: 5, assistantName: '患者调研' },
  6: { name: '线上推广', value: 6, assistantName: '线上推广' },
  7: { name: '医学调研', value: 7, assistantName: '医学调研' },
  8: { name: '医学病例收集', value: 8, assistantName: '医学病例收集' },
  9: { name: '等级医院拜访', value: 9, assistantName: '等级医院拜访' },
  10: {
    name: '基层医疗机构拜访',
    value: 10,
    assistantName: '基层医疗机构拜访'
  },
  11: {
    name: '特级三甲医院市场准入',
    value: 11,
    assistantName: '特级三甲医院市场准入'
  },
  12: {
    name: '三级医院市场准入',
    value: 12,
    assistantName: '三级医院市场准入'
  },
  13: {
    name: '二级医院市场准入',
    value: 13,
    assistantName: '二级医院市场准入'
  },
  14: {
    name: '基层医疗机构市场准入',
    value: 14,
    assistantName: '基层医疗机构市场准入'
  },
  15: {
    name: '零售药店市场准入',
    value: 15,
    assistantName: '零售药店市场准入'
  },
  16: { name: 'AI健康助手', value: 16, assistantName: 'AI健康助手' },
  17: { name: '数字拜访', value: 17, assistantName: '数字拜访' },
  18: { name: '病例收集', value: 18, assistantName: '病例收集' },
  19: { name: '协定服务', value: 19, assistantName: '协定服务' },
  20: { name: '可配置场景', value: 20, assistantName: '可配置场景' },
  21: { name: '数字问卷', value: 21, assistantName: '数字问卷' }
};

// 交易结构
export const taxCollectionPatternMap = {
  1: '汇总申报',
  2: '委托代开',
  3: '委托代发',
  4: '运营基地',
  5: '个体',
  6: '委托代开(线上)',
  9: '工具'
};
